import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../src/theme/getTheme';
import { FAB_PLUS_ICON_COLOR } from './FloatingCreateButton.constants';

/** FAB size: prominent circle that overlaps the tab bar (inspiration: bottom nav with central/right FAB) */
export const FAB_SIZE = 56;
const FAB_RADIUS = FAB_SIZE / 2;

/** Tab bar height; FAB sits slightly above it. */
const TAB_BAR_HEIGHT = 70;
/** FAB bottom offset: more of the FAB above the bar. */
const FAB_PADDING_BOTTOM = TAB_BAR_HEIGHT - FAB_RADIUS - 16;

export const getFloatingCreateButtonStyles = (theme: Theme, bottomPosition = 0) =>
  StyleSheet.create({
    wrapper: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: bottomPosition,
      height: TAB_BAR_HEIGHT + FAB_RADIUS,
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'center',
      paddingBottom: FAB_PADDING_BOTTOM,
      zIndex: 10001,
      elevation: 12,
    },
    containerHover: {
      ...(Platform.OS === 'web' && { opacity: 0.9 }),
    },
    button: {
      width: FAB_SIZE,
      height: FAB_SIZE,
      borderRadius: FAB_RADIUS,
      backgroundColor: theme.primary,
      justifyContent: 'center',
      alignItems: 'center',
      shadowColor: theme.black,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.35,
      shadowRadius: 8,
      elevation: 12,
      ...(Platform.OS === 'web' && { cursor: 'pointer' as const }),
    },
    buttonPressed: {
      opacity: 0.8,
    },
    plusIcon: {
      color: FAB_PLUS_ICON_COLOR,
      fontSize: 30,
      fontWeight: '200' as const,
      lineHeight: 30,
      textAlign: 'center',
      ...(Platform.OS === 'android' && { includeFontPadding: false }),
    },
    /** Dome-shaped half-circle (tab bar color) behind FAB so it reads as floating over a cutout */
    halfCircle: {
      position: 'absolute',
      left: '50%',
      marginLeft: -FAB_RADIUS,
      top: TAB_BAR_HEIGHT - FAB_PADDING_BOTTOM,
      width: FAB_SIZE,
      height: FAB_RADIUS,
      backgroundColor: theme.background.card,
      borderTopLeftRadius: FAB_RADIUS,
      borderTopRightRadius: FAB_RADIUS,
      zIndex: 0,
    },
    buttonContainer: {
      zIndex: 1,
    },
  });

